/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 30.10.17.
 */
import BaseValidator from "./BaseValidator";
import {t} from "../../../../trans";

class PasswordMatchValidator extends BaseValidator {
    validate(value) {
        if (!value.newPassword || !value.newPassword2) return null;
        if (value.newPassword != value.newPassword2) return {newPassword2: t("Password values do not match")};
        return null;
    }
}

export default PasswordMatchValidator;
